import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { union } from 'lodash';

const resource = (state, { type, payload }) => {
  switch (type) {
    case 'ESTIMATOR_RESOURCE_REQUEST':
      return {
        ...state,
        ...payload,
        loading: true,
      };
    case 'ESTIMATOR_RESOURCE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_CREATE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state,
        ...payload,
        loading: false,
      };
    default:
      return state;
  }
};

const byId = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'ESTIMATOR_RESOURCE_REQUEST':
    case 'ESTIMATOR_RESOURCE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_CREATE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_UPDATE_SUCCESS': {
      const id = payload.id !== null && payload.id !== undefined ?
                 payload.id : payload.result;
      // If payload has an id, it's a REQUEST action otherwise
      // the id is in the result field from normalizr
      const resourcePayload = payload.entities && payload.entities.estimators
                           && payload.entities.estimators[id];
      return {
        ...state,
        [id]: resource(state[id], { type, payload: resourcePayload }),
      };
    }
    case 'ESTIMATOR_LIST_SUCCESS':
      return Object.assign({}, state, payload.entities && payload.entities.estimators);
    case 'ADD_EVENT_TO_ESTIMATOR_SUCCESS': {
      const clonedState = Object.assign({}, state);
      clonedState[payload.estimatorId] = {
        ...clonedState[payload.estimatorId],
        events: 'events' in state[payload.estimatorId] ? [payload.event, ...state[payload.estimatorId].events] : [payload.event],
      };
      return clonedState;
    }
    case 'ADD_EVENT_TO_ESTIMATOR_FAILURE':
    default:
      return state;
  }
};

const defaultFilters = {
  data: {
    for_workrooms: [],
    is_active: true,
    is_pending: null,
    query: null,
  },
  idsByFilter: [],
};

const filters = (state = defaultFilters, { type, payload }) => {
  switch (type) {
    case 'ESTIMATOR_LIST_SUCCESS':
      return {
        ...state,
        idsByFilter: union(state.idsByFilter || [], payload.result.estimators),
      };
    case 'ESTIMATOR_SET_FILTER':
      return {
        ...state,
        data: Object.assign({}, payload),
      };
    case 'ESTIMATOR_RESET_FILTERS':
      return defaultFilters;
    case 'ESTIMATOR_RESOURCE_CREATE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_UPDATE_SUCCESS':
    case 'ESTIMATOR_RESET_PAGINATION':
      return {
        ...state,
        idsByFilter: [],
      };
    default:
      return state;
  }
};

const initialState = {
  loading: false,
  errors: {},
  page: 1,
  hasNextPage: true,
};

const common = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'ESTIMATOR_LIST_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'ESTIMATOR_RESOURCE_CREATE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state,
        page: 1,
        hasNextPage: true,
        errors: {},
      };
    case 'ESTIMATOR_RESET_PAGINATION':
      return {
        ...state,
        page: 1,
        hasNextPage: true,
      };
    case 'ESTIMATOR_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
        page: state.page + 1,
        hasNextPage: payload.result.has_next_page,
      };
    case 'ESTIMATOR_LIST_FAILURE':
    case 'ESTIMATOR_RESOURCE_CREATE_FAILURE':
    case 'ESTIMATOR_RESOURCE_UPDATE_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    case 'ESTIMATOR_RESOURCE_REQUEST':
    case 'ESTIMATOR_RESOURCE_SUCCESS':
    case 'ESTIMATOR_RESOURCE_CLEAR_VALIDATION':
      return {
        ...state,
        errors: {},
      };
    default:
      return state;
  }
};

const forZipState = {
  loading: false,
  errors: {},
  data: [],
};

const forZipCode = (state = forZipState, { type, payload }) => {
  switch (type) {
    case 'ESTIMATOR_RESOURCE_FOR_ZIP_CODE_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'ESTIMATOR_RESOURCE_FOR_ZIP_CODE_SUCCESS':
      return {
        ...state,
        loading: false,
        data: payload.estimators,
      };
    case 'ESTIMATOR_RESOURCE_FOR_ZIP_CODE_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  common,
  filters,
  forZipCode,
});

const getById = state => id => state.byId[id];
const getHasNextPage = state => state.common.hasNextPage;
const getPage = state => state.common.page;
const getLoading = state => state.common.loading;
const getErrors = state => state.common.errors;
const getFiltersData = state => state.filters.data;
const idsByFilter = state => state.filters.idsByFilter;

const getList = createSelector(
  getById,
  idsByFilter,
  (lookup, list) => list.map(id => lookup(id)),
);

export { getList, getHasNextPage, getPage, getLoading, getErrors, getById, getFiltersData };



// WEBPACK FOOTER //
// ./client/app/reducers/estimators.js